import { render, staticRenderFns } from "./Form_StaffReviewer.vue?vue&type=template&id=67e8fbd8&scoped=true"
import script from "./Form_StaffReviewer.vue?vue&type=script&lang=js"
export * from "./Form_StaffReviewer.vue?vue&type=script&lang=js"
import style0 from "./Form_StaffReviewer.vue?vue&type=style&index=0&id=67e8fbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8fbd8",
  null
  
)

export default component.exports